// removed by extract-text-webpack-plugin
module.exports = {"container":"TkPeRuXmKJ","paymentTAndC":"_3WO-u0HVfy"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/ConfirmPayment/ConfirmPayment.module.less
// module id = 974
// module chunks = 3